export const POST_TEXT = `POST_TEXT`;
export const POST_3DOTS = `POST_3DOTS`;
export const POST_LIKE = `POST_LIKE`;
export const TO_POST_DETAILS = `TO_POST_DETAILS`;
